import { render, staticRenderFns } from "./CustomerWidget.vue?vue&type=template&id=72caf313&scoped=true&"
import script from "./CustomerWidget.vue?vue&type=script&lang=ts&"
export * from "./CustomerWidget.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerWidget.vue?vue&type=style&index=0&id=72caf313&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72caf313",
  null
  
)

export default component.exports